import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import { TableCell } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Loading, Modal, Button } from "src/Components";
import { ICustomerReportScopeTableReport } from "src/Interfaces/reportLinks";
import { setIsCustomer } from "src/helper";
import { getCurrentUserInfo } from "src/Requests/customerReportRequests";
import {
  deleteCustomerReportScope,
  impersonateCustomerReportScope,
} from "src/Requests/reportLinksRequests";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";
import ChangePasswordModal from "./ChangePasswordModal";
import UpsertModal from "./UpsertModal";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: ICustomerReportScopeTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loginLoading, setLoginLoading] = React.useState(false);

  const deleteHandler = () => {
    setLoading(true);
    deleteCustomerReportScope({ id: row.id })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const handleLogin = () => {
    setLoginLoading(true);
    impersonateCustomerReportScope({ id: row.id })
      .then((res) => {
        localStorage.setItem("token", `Bearer ${res.token}`);
        localStorage.setItem("expiration", res.expiration.toString());
        setIsCustomer(res.isCustomer);
        if (res.isCustomer) {
          return getCurrentUserInfo().then(() => navigate("/iMEPortfolio"));
        }
        navigate("/sahra_user");
      })
      .catch((e) => {
        if (e.response?.data?.msg) toast.error(e.response.data.msg);
        else toast.error("خطا در ارتباط با سرور");
      })
      .finally(() => setLoginLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          onClick={handleLogin}
          text="ورود"
          variant="contained"
          className="table-btn"
          disabled={loginLoading}
          loading={loginLoading}
        />
      </TableCell>
      <TableCell>
        {isEditModalOpen ? (
          <Modal
            title="ویرایش لینک گزارش"
            UI={
              <UpsertModal
                editValues={{
                  id: row.id,
                  accountId: Number(row.accountId),
                  accessLink: row.accessLink,
                  username: row.username,
                  password: "",
                  shownName: row.shownName ?? "",
                }}
                accountName={row.accountName}
                onClose={() => setIsEditModalOpen(false)}
                onSuccess={onAction}
              />
            }
            onClose={() => setIsEditModalOpen(false)}
            modalBoxClassName="!min-w-[360px] z-[99999]"
          />
        ) : null}
        <div className="w-16 mx-auto" onClick={() => setIsEditModalOpen(true)}>
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        {isChangePasswordModalOpen ? (
          <Modal
            title="تغییر رمز عبور"
            UI={
              <ChangePasswordModal
                id={row.id}
                onClose={() => setIsChangePasswordModalOpen(false)}
                onSuccess={onAction}
              />
            }
            onClose={() => setIsChangePasswordModalOpen(false)}
            modalBoxClassName="!min-w-[360px] !min-h-min z-[99999]"
          />
        ) : null}
        <div
          className="w-16 mx-auto"
          onClick={() => setIsChangePasswordModalOpen(true)}
        >
          <LockResetIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        <div className="w-16 mx-auto" onClick={deleteHandler}>
          {loading ? (
            <Loading size={16} className="!text-slate-700" />
          ) : (
            <DeleteIcon className="!text-red-700 cursor-pointer" />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<ICustomerReportScopeTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
